import React from 'react';
import InfographicPie from '../../../../components/infographic-pie/infographic-pie';
import { useIntl } from 'react-intl';
import {pirBoxCardMessages, PirPositionTypesEnum, PirTypesEnumReverse} from 'azshared';
import './pir-box-pie-chart.scss';
import { PirBoxProductSummary } from 'azshared/build/main/lib/model/pirbox/pirbox-product-summary';

export interface PirBoxPieChartProps {
  summary: PirBoxProductSummary;
}

export const PirBoxPieChart = (props: PirBoxPieChartProps) => {
  const { formatMessage } = useIntl();
  const { summary } = props;
  const type = summary.pirType;
  const title = type === PirTypesEnumReverse.UCITS ? pirBoxCardMessages.ordinaryDepositTitle : pirBoxCardMessages.alternativeDepositTitle;
  const percentualeCompliant = summary.productsDetails.find((detail) => detail.typology === PirPositionTypesEnum.Qualificata)?.percentage ?? 0;
  const percentualeNoCompliant = summary.productsDetails.find((detail) => detail.typology === PirPositionTypesEnum.NonQualificata)?.percentage ?? 0;
  return (
    <div>
      <h4 className='pir-box-pie-chart-title'>
        {formatMessage(title)} - {formatMessage(pirBoxCardMessages.composition)}
      </h4>
      <InfographicPie
        legend
        customStyle={{'width':'100%'}}
        items={[
          {
            value: percentualeCompliant,
            label: formatMessage(pirBoxCardMessages.qualified)
          },
          { value: percentualeNoCompliant,
            label: formatMessage(pirBoxCardMessages.notQualified)
          }
        ]}
      />
    </div>
  );
};
